// @ts-strict-ignore
import {Component, Input, output, TemplateRef} from "@angular/core";
import {Translations} from "@translations";
import {AssessablePanelMode} from "@common/components/assessment/utils";

@Component({
	selector: "sim-free-answer-item",
	template: `
		<mat-form-field color="accent" class="full-width-form">
			<mat-label>{{
				(mode === AssessablePanelMode.Edit ? T.SHARED_EXPANSION_ANSWER_EDIT : T.SHARED_EXPANSION_ANSWER) | translate
			}}</mat-label>
			<textarea
				matInput
				cdkTextareaAutosize
				[disabled]="mode !== AssessablePanelMode.Answer || disabled"
				[rows]="mode === AssessablePanelMode.Edit ? 1 : 3"
				[ngModel]="answer"
				(ngModelChange)="onFreeTextAnswerChanged.emit($event)"
				[cdkAutosizeMaxRows]="6"
			></textarea>
		</mat-form-field>

		@if (!hideScore) {
			<div class="freeTextPoints">
				<ng-container *ngTemplateOutlet="freeTextPointsTemplate" />
			</div>
		}
	`,
	styleUrls: ["./free-answer-item.component.scss"],
	standalone: false,
})
export class FreeAnswerItemComponent {
	protected readonly T = Translations;
	protected readonly AssessablePanelMode = AssessablePanelMode;

	@Input() mode: AssessablePanelMode = AssessablePanelMode.View;
	@Input() answer: any;
	@Input() hideScore: boolean = false;
	@Input() freeTextPointsTemplate: TemplateRef<any>;
	@Input() disabled = false;

	onFreeTextAnswerChanged = output<string>();
}
